<app-auth-container>
  <ng-template #content>
    <div class="auth-form-card">
      <h1 class="font-weight-700">
        {{ "Login.COMPLETE_REGISTRATION" | translate }}
      </h1>
      <p class="mb-4">
        {{ "Login.WELCOME_TO" | translate }} <a>{{ companyName }}</a>
      </p>
      <form #formGroup="ngForm" class="mt-4">
        <div class="app-form-control">
          <label class="input-label" for="nationalId">{{
            "Login.YOUR_IQAMA" | translate
          }}</label>
          <div class="w-100">
            <input
              type="text"
              class="w-100"
              placeholder="0000 0000 0000 0000"
              name="nationalId"
              id="nationalId"
              maxlength="10"
              appNumbersOnly
              [pattern]="nationalIdPattern"
              [(ngModel)]="nationalId"
              #nationalIdRef="ngModel"
              required
            />
          </div>
          <mat-error
            *ngIf="nationalIdRef.errors && nationalIdRef.errors['required']"
            >{{ "Shared.REQUIRED" | translate }}
          </mat-error>
          <mat-error
            id="error_national_valid"
            *ngIf="nationalIdRef.errors && nationalIdRef.errors['pattern']"
          >
            {{ "Login.IQAMA_NOT_VALID" | translate }}
          </mat-error>
        </div>

        <button
          type="button"
          class="btn-block mt-4"
          [disabled]="!nationalId || nationalIdRef.invalid"
          (click)="verifyInvitedUser()"
        >
          {{ "Shared.CONTINUE" | translate }}
        </button>
      </form>
    </div>
  </ng-template>
</app-auth-container>
